import { onUnmounted, watch, type Ref } from 'vue'

const ASSISTANT_PANEL_SELECTOR = '.cplug-assistant > div'

function applyAssistantEmbedStyles (container: HTMLElement): void {
  const assistantRoot = container.querySelector<HTMLElement>('.cplug-assistant')
  if (!assistantRoot) {
    return
  }

  assistantRoot.style.setProperty('position', 'absolute', 'important')
  assistantRoot.style.setProperty('inset', '0', 'important')
  assistantRoot.style.setProperty('top', '0', 'important')
  assistantRoot.style.setProperty('right', '0', 'important')
  assistantRoot.style.setProperty('bottom', '0', 'important')
  assistantRoot.style.setProperty('left', '0', 'important')
  assistantRoot.style.setProperty('display', 'flex', 'important')
  assistantRoot.style.setProperty('flex-direction', 'column', 'important')
  assistantRoot.style.setProperty('align-items', 'stretch', 'important')
  assistantRoot.style.setProperty('gap', '0', 'important')
  assistantRoot.style.setProperty('width', '100%', 'important')
  assistantRoot.style.setProperty('height', '100%', 'important')
  assistantRoot.style.setProperty('max-width', 'none', 'important')
  assistantRoot.style.setProperty('max-height', 'none', 'important')
  assistantRoot.style.setProperty('margin', '0', 'important')
  assistantRoot.style.setProperty('z-index', '1', 'important')

  container.querySelectorAll<HTMLElement>(ASSISTANT_PANEL_SELECTOR).forEach((panel) => {
    panel.style.setProperty('flex', '1 1 auto', 'important')
    panel.style.setProperty('width', '100%', 'important')
    panel.style.setProperty('height', '100%', 'important')
    panel.style.setProperty('min-height', '0', 'important')
    panel.style.setProperty('max-width', 'none', 'important')
    panel.style.setProperty('max-height', 'none', 'important')
    panel.style.setProperty('margin', '0', 'important')
    panel.style.setProperty('border-radius', '0', 'important')
    panel.style.setProperty('box-shadow', 'none', 'important')
    panel.style.setProperty('transform', 'none', 'important')
    panel.style.setProperty('opacity', '1', 'important')
  })
}

/**
 * Re-posiciona o AssistantModal (FAB fixed no pacote) dentro da sidebar do ERP.
 * CSS externo não vence `position: fixed !important` inline — aplicamos via JS.
 */
export function useAssistantEmbedLayout (containerRef: Ref<HTMLElement | null>): void {
  let observer: MutationObserver | null = null

  function sync (): void {
    const container = containerRef.value
    if (!container) {
      return
    }

    applyAssistantEmbedStyles(container)
  }

  watch(containerRef, (container) => {
    observer?.disconnect()
    observer = null

    if (!container) {
      return
    }

    sync()

    observer = new MutationObserver(sync)
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    })
  }, { immediate: true })

  onUnmounted(() => {
    observer?.disconnect()
    observer = null
  })
}
